module.exports = __webpack_public_path__ + "static/media/icon_sakura4ab153ad20efcd40b8289b8d7a7199be.webp";